module.exports = __webpack_public_path__ + "assets/540d78dd4b3112534a6e5f7869e93a9a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/reel_start.mp3
 ** module id = 216
 ** module chunks = 0
 **/